import { useDispatch } from "react-redux";
import { getTypes } from "../../../redux/features/categoryAndType/categoryAndTypeSlice";
import "./Type.scss";
import TypeList from "./TypeList";
import CreateType from "./CreateType";

const Type = () => {
  return (
    <section>
      <div className="container coupon">
        <CreateType />
        <TypeList />
      </div>
    </section>
  );
};
export default Type;
